export default __webpack_public_path__ + "media/images/about_us/roles/dino-meoni-23d9b687a01745b491497363ba256280.png";